import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import styles from "./Display.module.scss"
import { DotColor } from "./DotColor"
import { GraphIconScale } from "./GraphIconScale"
import { GraphRange } from "./GraphRange"
import { ShowDifference } from "./ShowDifference"

import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useDebouncedUpdater,
  useUpdateDeviceSettings,
} from "src/hooks"

export function Display() {
  const polyglot = usePolyglot()

  const {
    currentUserId,
    currentDeviceSettings,
    currentFollow,
  } = useFollowedUsers()
  const deviceSettingsId = currentDeviceSettings.id
  const updatedAt = currentDeviceSettings.updated_at

  // TODO catch error and show toast
  const updateDeviceSettings = useUpdateDeviceSettings()
  const debouncedUpdateDeviceSettings = useDebouncedUpdater({ updater: updateDeviceSettings })

  const debouncedUpdateDeviceSettingsWithId = useCallback(
    (deviceSettings: Partial<DeviceSettings>) => debouncedUpdateDeviceSettings({
      id: deviceSettingsId,
      ...deviceSettings,
    }),
    [
      debouncedUpdateDeviceSettings,
      deviceSettingsId,
    ],
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.display")}
      backRoutePath={currentFollow.is_self ? "/settings" : "/settings/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        <GraphRange
          updatedAt={updatedAt}
          updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
        />
        <ShowDifference
          updatedAt={updatedAt}
          updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
        />
        <DotColor
          updatedAt={updatedAt}
          updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
        />
        <GraphIconScale
          updatedAt={updatedAt}
          updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
        />
      </div>
    </PageTemplate>
  )
}
